export const SpecialColumnsIds = {
  ACTIONS: 'actions',
  STATE: 'state',
} as const;
